/**
 * 懒加载Lazy_use
 */
import Vue from 'vue'
import {
  Descriptions,
  Switch,
  Avatar,
  Alert,
  BackTop,
  Row,
  Result,
  Col,
  Cascader,
  Drawer,
  Dropdown,
  Divider,
  Radio,
  Layout,
  Menu,
  Badge,
  Icon,
  Card,
  Empty,
  Form,
  Table,
  Input,
  InputNumber,
  Button,
  Checkbox,
  Tabs,
  Upload,
  message,
  notification,
  Select,
  Modal,
  ConfigProvider,
  DatePicker,
  TimePicker,
  Spin,
  Steps,
  Popconfirm,
  FormModel,
  Carousel,
  Rate,
  Breadcrumb,
  List,
  Collapse,
  Pagination,
  Progress,
  Tag,
  Affix,
  Tree,
} from 'ant-design-vue'

Vue.use(BackTop)
Vue.use(Drawer)
Vue.use(Descriptions)
Vue.use(Empty)
Vue.use(List)
Vue.use(Pagination)
Vue.use(Switch)
Vue.use(Cascader)
Vue.use(Alert)
Vue.use(Divider)
Vue.use(Steps)
Vue.use(Radio)
Vue.use(Avatar)
Vue.use(Badge)
Vue.use(Tabs)
Vue.use(Checkbox)
Vue.use(Dropdown)
Vue.use(Layout)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Table)
Vue.use(Card)
Vue.use(Form)
Vue.use(Modal)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Upload)
Vue.use(Select)
Vue.use(Result)
Vue.use(ConfigProvider)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Spin)
Vue.use(Popconfirm)
Vue.use(FormModel)
Vue.use(Carousel)
Vue.use(Rate)
Vue.use(Breadcrumb)
Vue.use(Collapse)
Vue.use(Progress)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Tree)

Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$info = Modal.info
Vue.prototype.$success = Modal.success
Vue.prototype.$error = Modal.error
Vue.prototype.$warning = Modal.warning

Vue.config.productionTip = false
